<script>
import Layout from '@layouts/main'
import StatusService from '@/src/services/status'


export default {
  components: {
    Layout
  },
  data() {
    return {
      statusListFields: [
        {
          key: 'namestatus',
          label: 'Status',
        },
        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 10,
      statusList: [],
      isLoading: false,
      idStatus: '',
      isShowHideForm: true,
      isEdit: false,
      status: {},
      isModalDelete: false
    }
  },
  computed: {
    rows() {
      return this.statusList.length
    },
  },
  watch: {},
  mounted() {
    this.getAll();
  },
  methods: {
    openForm() {
      this.status = {}
      this.isEdit = false
      this.isShowHideForm = !this.isShowHideForm
    },
    modalDelete(item) {
      this.isModalDelete = true
      this.idStatus = item
    },
    modalEdit(item) {
      this.isEdit = true
      this.status = {
        namestatus: item.namestatus,
      }
      this.idStatus = item.idstatus
      this.isShowHideForm = false
    },
    handleDelete() {
      this.isLoading = true
      StatusService.delete(this.idStatus)
        .then(() => {
          this.$bvToast.toast('Success removed!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.getAll()
        })
        .finally(() => {
          this.isLoading = false
          this.isModalDelete = false
        })
    },
    handleCreate() {
      this.isLoading = true
      StatusService.create(this.status)
        .then((response) => {
          this.$bvToast.toast('Success saved!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.status = response.data.dados
        })
        .finally(() => {
          this.isLoading = false
          this.isShowHideForm = !this.isShowHideForm
          this.getAll()
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro salved',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    handleEdit() {
      this.isLoading = true
      StatusService.update(this.status, this.idStatus)
        .then((response) => {
          this.$bvToast.toast('Success edited!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.status = response.data.dados
        })
        .finally(() => {
          this.isLoading = false
          this.isShowHideForm = !this.isShowHideForm
          this.getAll()
        })
        .catch(() => {
          this.$bvToast.toast(
            'Error edited',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    getAll() {
      this.isLoading = true
      StatusService.findAll().then((response) => {
        this.statusList = response.data
        this.isLoading = false
      })
    },
    validateForm() {
      this.isEdit ? this.handleEdit() : this.handleCreate()
    },
  },
}
</script>
<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Register Status</div>
          </div>
          <div class="col-md-2 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary" @click="openForm">
              <span v-if="isShowHideForm">New</span>
              <span v-else>List</span>
            </button>
          </div>

        </div>
        <div class="row">
          <div v-if="isShowHideForm" class="col-md-12">
            <div class="borda"></div>
            <b-table striped hover :items="statusList" :fields="statusListFields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(actions)="row">
                <div class="btn-group mb-2">
                  <button
v-b-tooltip.hover title="Editar" type="button" class="btn btn-light"
                    @click="modalEdit(row.item)">
                    <i class="uil uil-edit-alt"></i>
                  </button>
                  <button
v-b-tooltip.hover title="Deletar" type="button" class="btn btn-light"
                    @click="modalDelete(row.item.idStatus)">
                    <i class="uil uil-trash-alt"></i>
                  </button>
                </div>
              </template>
            </b-table>
            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
          </div>
          <div v-else class="col-md-12 row">
            <div class="col-md-12 row">
              <b-form-group label="Status" label-for="statusList" class="col-md-4">
                <b-input id="input-namestatus" v-model="status.namestatus" type="text">
                </b-input>
              </b-form-group>
              <div class="col-md-12"></div>
            </div>
            <div class="col-md-12">
              <b-button variant="primary" @click="validateForm">
                Save
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="borda"></div>
    </div>
    <b-modal v-model="isModalDelete" title="Aviso" title-class="font-18">
      <p>Are you sure you want to delete this record?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">No</b-button>
        <b-button variant="danger" @click="handleDelete">Yes</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap></b-overlay>
  </Layout>
</template>